import { Folder, Globe2, Server } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import type { TradeIdeasRuntimeConfig } from "@/lib/tradeideas/types";

export function RuntimeConfigPanel({ config }: { config: TradeIdeasRuntimeConfig }) {
  return (
    <Card className="rounded-md">
      <CardHeader>
        <CardTitle>Runtime Config</CardTitle>
        <CardDescription>SQLite-backed settings currently used by the daemon.</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-3 md:grid-cols-3">
        <RuntimeItem
          icon={Folder}
          label="Watch directory"
          value={config.tradeideas.watch_directory}
        />
        <RuntimeItem
          icon={Globe2}
          label="CSV pattern"
          value={config.tradeideas.csv_pattern}
        />
        <RuntimeItem
          icon={Server}
          label="Machine"
          value={config.host.alias || config.host.hostname || "unknown"}
        />
        <div className="flex flex-wrap gap-2 md:col-span-3">
          <Badge variant={config.mode === "active" ? "success" : "warn"}>
            {config.mode}
          </Badge>
          <Badge variant={config.polling_enabled ? "success" : "outline"}>
            {config.polling_enabled ? "polling enabled" : "polling paused"}
          </Badge>
          <Badge variant="outline">{config.delivery.sinks.length} sinks</Badge>
        </div>
      </CardContent>
    </Card>
  );
}

function RuntimeItem({
  icon: Icon,
  label,
  value,
}: {
  icon: React.ElementType;
  label: string;
  value: string;
}) {
  return (
    <div className="min-w-0 rounded-md border border-border bg-bg/40 p-3">
      <div className="flex items-center gap-2 text-xs text-muted-fg">
        <Icon className="size-4" />
        {label}
      </div>
      <div className="mt-2 truncate font-mono text-xs">{value}</div>
    </div>
  );
}
